<template>
    <div id="app" class="modal">
        <div class="modal-window">
            <div class="content">
                <div v-if="errorType=='gateway'">
                    <div v-if="!customer" v-html="errorGatewayLoggedOutMsg">
                        {{errorGatewayLoggedOutMsg}}
                    </div>
                    <div v-else v-html="errorGatewayLoggedInMsg">
                        {{errorGatewayLoggedInMsg}}
                    </div>
                </div>

                <div v-else>
                    <div v-if="!customer" v-html="expiredCardLoggedOutMsg">
                        {{expiredCardLoggedOutMsg}}
                    </div>
                    <div v-else v-html="expiredCardLoggedInMsg">
                        {{expiredCardLoggedInMsg}}
                    </div>
                </div>
            </div>

            <div class="actions">
                <button class="confirm" @click="addCard">
                    {{t('Tilføj nyt betalingskort')}}
                </button>
                <button class="cancel" @click="onCancel">
                    {{t('Annuller')}}
                </button>
            </div>
        </div>
    </div>
</template>

<script>
import VueStarRating from 'vue-star-rating'
import axios from 'axios'
export default {
    name: 'ReviewConsultant',

    props: {
        customer: {
            type: Object,
            default: null
        },
        customerData: {
            type: Object,
            default: null
        },
        redirectionLink: {
            type: String,
            default: null
        },
        errorType: {
            type: String,
            default: null
        }
    },

    data () {
        return {
            errorGatewayLoggedOutMsg : '',
            errorGatewayLoggedInMsg : '',
            expiredCardLoggedOutMsg : '',
            expiredCardLoggedInMsg : ''
        }
    },

    mounted() {
        if (typeof window.serverUrl !== 'undefined') {
            this.serverUrl = window.serverUrl;
        }

        if (typeof window.errorGatewayLoggedOutMsg !== 'undefined' || window.errorGatewayLoggedOutMsg !== '') {
            this.errorGatewayLoggedOutMsg = window.errorGatewayLoggedOutMsg;
        }
        else {
            this.errorGatewayLoggedOutMsg = `<p>Kære kunde</p>

                    <p>På grund af nye EU krav til sikkerhed ved online betalinger (PSD2) har vi hos Klarsyn24 opdateret vores betalingsløsning på hjemmesiden.</p>

                    <p>Dette betyder, at du som kunde bliver nød til at opdatere dit betalingskort på din Klarsyn24 konto og godkende på ny.</p>

                    <p>Vi beklager denne ulejlighed, men vi tager vores kunders sikkerhed omkring betaling meget alvorligt og håber på forståelse.</p>

                    <p>Opdater dit betalingskort <button @click="addCard">her</button> - alternativt klik på "Log ind" i Navigerings Menu her på siden.</p>

                    <p>Vi ser frem til at servicere dig igen.</p>
                    <p>Hilsen Klarsyn24</p>`;
        }
        if (typeof window.errorGatewayLoggedInMsg !== 'undefined' || window.errorGatewayLoggedInMsg !== '') {
            this.errorGatewayLoggedInMsg = window.errorGatewayLoggedInMsg;
        }
        else {
            this.errorGatewayLoggedInMsg = `<p>Kære kunde</p>

                    <p>På grund af nye EU krav til sikkerhed ved online betalinger (PSD2) har vi hos Klarsyn24 opdateret vores betalingsløsning på hjemmesiden.</p>

                    <p>Dette betyder, at du som kunde bliver nød til at opdatere dit betalingskort på din Klarsyn24 konto og godkende på ny.</p>

                    <p>Vi beklager denne ulejlighed, men vi tager vores kunders sikkerhed omkring betaling meget alvorligt og håber på forståelse.</p>

                    <p>Opdater dit betalingskort <button @click="addCard">her</button> - alternativt klik på "Min konto" i Navigerings Menu her på siden.</p>

                    <p>Vi ser frem til at servicere dig igen.</p>
                    <p>Hilsen Klarsyn24</p>`;
        }
        if (typeof window.expiredCardLoggedOutMsg !== 'undefined' || window.expiredCardLoggedOutMsg !== '') {
            this.expiredCardLoggedOutMsg = window.expiredCardLoggedOutMsg;
        }
        else {
            this.expiredCardLoggedOutMsg = `<p>Kære kunde</p>

                    <p>Det betalingskort du har knyttet til din konto hos Klarsyn24 er desværre udløbet.</p>

                    <p>For igen at kunne ringe til vores konsulenter bliver du nød til at opdatere dit betalingskort på din Klarsyn24 konto.</p>

                    <p>Opdater dit betalingskort <button @click="addCard">her</button> - alternativt klik på "Log ind" i Navigerings Menu her på siden.</p>

                    <p>Vi ser frem til at servicere dig igen.</p>
                    <p>Hilsen Klarsyn24</p>`;
        }
        if (typeof window.expiredCardLoggedInMsg !== 'undefined' || window.expiredCardLoggedInMsg !== '') {
            this.expiredCardLoggedInMsg = window.expiredCardLoggedInMsg;
        }
        else {
            this.expiredCardLoggedInMsg = `<p>Kære kunde</p>

                    <p>Det betalingskort du har knyttet til din konto hos Klarsyn24 er desværre udløbet.</p>

                    <p>For igen at kunne ringe til vores konsulenter bliver du nød til at opdatere dit betalingskort på din Klarsyn24 konto.</p>

                    <p>Opdater dit betalingskort <button @click="addCard">her</button> - alternativt klik på "Min konto" i Navigerings Menu her på siden.</p>

                    <p>Vi ser frem til at servicere dig igen.</p>
                    <p>Hilsen Klarsyn24</p>`;
        }
    },

    methods: {
        addCard() {
            axios({
                method: 'post',
                url   : this.serverUrl+this.redirectionLink,
                headers: {
                        "X-WP-Nonce": window.nonce
                },
                data  : this.customerData
            })
            .then(function (response) {
                if (response.data['status']=='success') {
                    window.location.href = response.data.altapay_url;
                }
                else {
                    console.log(response);
                }
            }.bind(this))
            .catch(function (error) {
                console.log(error);
            })
        },

        onCancel() {
            this.$emit("hideError");
        }
    }
}
</script>

<style scoped>
.modal {
    position: fixed;
    top: 0;
    left: 0;
    bottom: 0;
    right: 0;
    background: rgba(0, 0, 0, .5);
    z-index: 3;
    width: 100%;
}

.modal-window {
    position: absolute;
    top: 50%;
    left: 50%;
    transition: .5s;
    width: 40%;
    min-width: 400px;
    max-width: 600px;
    background: white;
    box-shadow: 0 0 10px rgba(0, 0, 0, .5);
    transform: translate(-50%, -50%);
    padding: 1em;
    color: black;
    text-align: center;
}
.actions button {
    font-size: inherit;
    margin: 4px;
    border: none;
    padding: 6px 8px;
    cursor: pointer;
}

.actions .confirm {
    background: darkcyan;
    color: white;
}

.actions .cancel {
    background: darkred;
    color: white;
}

.content {
    text-align: left;
}

.content button {
    border: none;
    background: none;
    color: #5e74bc;
}

.content button:hover {
    color: #d1b168;
}

button {
    cursor: pointer;
}

</style>



// WEBPACK FOOTER //
// src/components/GatewayError.vue